// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\BerthManagerDashboard\ActivityFeedResponse.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { ActivityFeedNewReservation as _ActivityFeedNewReservation, ActivityFeedNewReservationData as _ActivityFeedNewReservationData, ActivityFeedNewReservationOptions as _ActivityFeedNewReservationOptions } from 'data/models/ActivityFeedResponse';
import { BerthReservation, BerthReservationData, BerthReservationOptions } from 'data/models/BerthReservation';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { PortCallChange, PortCallChangeData, PortCallChangeOptions } from 'data/models/PortCallChange';
import { RecurringBatch, RecurringBatchData, RecurringBatchOptions } from 'data/models/RecurringBatch';
import { RecurringBatchChange, RecurringBatchChangeData, RecurringBatchChangeOptions } from 'data/models/RecurringBatchChange';
import { TopicCardChange, TopicCardChangeData, TopicCardChangeOptions } from 'data/models/TopicCardChange';

// ActivityFeedResponseData is the class that ActivityFeedResponse serializes to/from
export interface ActivityFeedResponseData {
    OrganizationId : number;
	
    ChangedBatches : RecurringBatchChangeData[] | null;
    ChangedReservations : PortCallChangeData[] | null;
    ChangedTopicCards : TopicCardChangeData[] | null;
    ConflictedBatches : RecurringBatchData[] | null;
    ConflictedReservations : BerthReservationData[] | null;
    NewBatches : RecurringBatchData[] | null;
    NewReservations : _ActivityFeedNewReservationData[] | null;
    OpenReservations : BerthReservationData[] | null;
	
}

// ActivityFeedResponseOptions is the class which may be passed to the ActivityFeedResponse constructor to define optional initial data values
export interface ActivityFeedResponseOptions {
    OrganizationId : number;
	
    ChangedBatches? : RecurringBatchChangeOptions[] | null;
    ChangedReservations? : PortCallChangeOptions[] | null;
    ChangedTopicCards? : TopicCardChangeOptions[] | null;
    ConflictedBatches? : RecurringBatchOptions[] | null;
    ConflictedReservations? : BerthReservationOptions[] | null;
    NewBatches? : RecurringBatchOptions[] | null;
    NewReservations? : _ActivityFeedNewReservationOptions[] | null;
    OpenReservations? : BerthReservationOptions[] | null;
	
}

export class ActivityFeedResponse {
    public OrganizationId : DataSignal<number>;
	
    public ChangedBatches : SDataArray<RecurringBatchChange>;
    public ChangedReservations : SDataArray<PortCallChange>;
    public ChangedTopicCards : SDataArray<TopicCardChange>;
    public ConflictedBatches : SDataArray<RecurringBatch>;
    public ConflictedReservations : SDataArray<BerthReservation>;
    public NewBatches : SDataArray<RecurringBatch>;
    public NewReservations : SDataArray<_ActivityFeedNewReservation>;
    public OpenReservations : SDataArray<BerthReservation>;
	

    constructor();
    constructor(data : ActivityFeedResponseOptions);
    constructor(data: ActivityFeedResponseOptions | null = null) {
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
	    
        this.ChangedBatches = SArray<RecurringBatchChange>([]);
        this.ChangedReservations = SArray<PortCallChange>([]);
        this.ChangedTopicCards = SArray<TopicCardChange>([]);
        this.ConflictedBatches = SArray<RecurringBatch>([]);
        this.ConflictedReservations = SArray<BerthReservation>([]);
        this.NewBatches = SArray<RecurringBatch>([]);
        this.NewReservations = SArray<_ActivityFeedNewReservation>([]);
        this.OpenReservations = SArray<BerthReservation>([]);
	    
    }

    static key(obj : ActivityFeedResponse) {
        return obj.OrganizationId();
    }
    
    static dataKey(obj : ActivityFeedResponseOptions) {
        return obj.OrganizationId;
    }

    static update(obj : ActivityFeedResponse, data : ActivityFeedResponseOptions) {
        S.freeze(() => {
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
	        
	        
        });
    }
}

// ActivityFeedNewReservationData is the class that ActivityFeedNewReservation serializes to/from
export interface ActivityFeedNewReservationData {
    Id : number;
	
    Requestor : PCUserData | null;
    RequestorId : number;
    Reservation : BerthReservationData | null;
	
}

// ActivityFeedNewReservationOptions is the class which may be passed to the ActivityFeedNewReservation constructor to define optional initial data values
export interface ActivityFeedNewReservationOptions {
    Id : number;
	
    Requestor? : PCUserOptions | null;
    RequestorId? : number;
    Reservation? : BerthReservationOptions | null;
	
}

export class ActivityFeedNewReservation {
    public Id : DataSignal<number>;
	
    public Requestor : DataSignal<PCUser | null>;
    public RequestorId : DataSignal<number>;
    public Reservation : DataSignal<BerthReservation | null>;
	

    constructor();
    constructor(data : ActivityFeedNewReservationOptions);
    constructor(data: ActivityFeedNewReservationOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Requestor = S.value<PCUser | null>(null);
        this.RequestorId = jsonableObservable(S.value<number>(data && data.RequestorId !== undefined ? data.RequestorId : 0));
        this.Reservation = S.value<BerthReservation | null>(null);
	    
    }

    static key(obj : ActivityFeedNewReservation) {
        return obj.Id();
    }
    
    static dataKey(obj : ActivityFeedNewReservationOptions) {
        return obj.Id;
    }

    static update(obj : ActivityFeedNewReservation, data : ActivityFeedNewReservationOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.RequestorId !== undefined) obj.RequestorId(data.RequestorId);
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ActivityFeedResponse.ts